var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "59px",
    viewBox: "0 0 78 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RYSST---concept---full-page---new-3",
    transform: "translate(-121.000000, -3157.000000)",
    fillRule: "nonzero",
    stroke: "#00BDF1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u201C",
    transform: "translate(122.000000, 3158.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,35.9312321 C0,49.3237822 8.95074946,57 18.8779443,57 C27.9914347,57 35.8029979,49.3237822 35.8029979,39.8510029 C35.8029979,30.7048711 29.4561028,24.6618911 21.6445396,24.6618911 C19.8543897,24.6618911 18.2269807,24.9885387 17.4132762,25.3151862 C19.5289079,19.1088825 27.0149893,11.9226361 32.2226981,9.63610315 L20.3426124,0 C7.64882227,8.98280802 0,21.5587393 0,35.9312321 Z M40.1970021,35.9312321 C40.1970021,49.3237822 49.1477516,57 59.0749465,57 C68.1884368,57 76,49.3237822 76,39.8510029 C76,30.7048711 69.6531049,24.6618911 61.8415418,24.6618911 C60.0513919,24.6618911 58.4239829,24.9885387 57.6102784,25.3151862 C59.7259101,19.1088825 67.2119914,11.9226361 72.4197002,9.63610315 L60.5396146,0 C47.8458244,8.98280802 40.1970021,21.5587393 40.1970021,35.9312321 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteShape);
export default __webpack_public_path__ + "static/media/quote-shape.81306d93ec44c366ee0b960f38e44a6a.svg";
export { ForwardRef as ReactComponent };